import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import ImageEditor from './EditorPages/ImageEditor';
import ImageResults from './ResultsPages/ImageResults';

function Images({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <ImageEditor id={queryParams['id']} /> :
            <ImageResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Images);